
module.config(function($stateProvider) {
    return;

    $stateProvider.state('reports.affnet.report', {
        templateUrl: function(params) {
            return 'reports/affnet/' + params.reportName;
        },
        reloadOnSearch: false,
        url: '/:reportName',
        data: {defaultSort: 'name' },
        permission: 'indexPrograms',
        resolve: {
            report: function($stateParams, ReportService) {
                return ReportService.getFieldDetailReport($stateParams.reportName);
            },
        },
        controller: 'AffnetReportController',
    });

    $stateProvider.state('program.reports.affnet.report', {
        templateUrl: function(params) {
            return 'reports/affnet/' + params.reportName + 'Students';
        },
        reloadOnSearch: false,
        url: '/:reportName',
        data: {defaultSort: 'sort_name'},
        controller: 'AffnetReportController',
        permission: 'viewStudents',
        instead: 'program.reports.affnet.index',
        resolve: {
            report: function($stateParams, ReportService, program) {
                return ReportService.getProgramDetailReport(
                    $stateParams.reportName,
                    program);
            }
        }
    });
});


module.cC({
    name: 'AffnetReportController',
    inject: ['$scope', '$state', '$stateParams', '$location', 'report'],
    data: {
        report: 'report',
        stateData: '$state.current.data',
        filters: '{}',
    },

    init: function() {
        var search = this.$location.search();
        this.filters.page = search.page || 1;
        this._setSort(search.sort || this.stateData.defaultSort);
    },

    watch: {
        '{collection}filters': '_updateData',
        '{object}params': '_updateParams',
    },

    methods: {

        _getSort: function() {
            return (this.filters.direction == 'asc' ? '' : '-') +
                this.filters.sort;
        },

        _setSort: function(value) {
            if (value[0] === '-') {
                this.filters.direction = 'desc';
                this.filters.sort = value.substr(1);
            } else {
                this.filters.direction = 'asc';
                this.filters.sort = value;
            }
        },

        _updateData: function(filters) {
            if (!filters.params) return;
            var queryParams = angular.copy(filters.params);
            queryParams.page = filters.page;
            queryParams.sort = this._getSort();
            if (this.program) queryParams['program-id'] = this.program.id;
            this._setLocation('sort', queryParams.sort, this.stateData.defaultSort);
            this._setLocation('page', queryParams.page, 1);
            this.report.update(queryParams);
        },

        _updateParams: function(params) {
            this.filters.page = 1;
            this.filters.params = angular.copy(params);
        },

        _setLocation: function(name, value, defaultValue) {
            if (value === defaultValue) {
                this.$location.search(name, undefined);
            } else {
                this.$location.search(name, value)
            }
        },

        getParams: function(program) {
            var params = {};
            angular.extend(params, this.$stateParams, this.$.params);
            params.slug = program.slug;
            return params;
        },
    },
});
